import { Component, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { ErrorLogResponse } from '../../models/profile';
import { QuestionErrorService } from '../../services/question-error.service';
import { ErrorLogSaveComponent } from '../error-log-save/error-log-save.component';

@Component({
  selector: 'app-error-logs-list',
  templateUrl: './error-logs-list.component.html',
  styleUrls: ['./error-logs-list.component.scss'],
})
export class ErrorLogsListComponent implements OnInit {
  errorList: Array<ErrorLogResponse> = [];
  databaseError: boolean = false;
  constructor(
    private questionErrorService: QuestionErrorService,
    private loadingService: LoadingService,
    private modalService: ModalService) { }

  ngOnInit() { }

  ionViewDidEnter() {
    this.getErrorList();
  }

  getErrorList() {
    this.loadingService.showLoading();
    this.questionErrorService.getErrorLogs().subscribe(e => {
      this.loadingService.hideLoading();
      if (e.IsSuccess) {
        this.databaseError = false;
        this.errorList = e.Data;
      } else {
        this.databaseError = true;
      }
    }, err => {
      this.loadingService.hideLoading();
      this.databaseError = true;
    });
  }

  addError() {
    this.modalService.presentModal({
      component: ErrorLogSaveComponent,
      componentProps: {},
      options: ModalService.defaultOptionsTransparent,
    }).then(e => {
      e.modalObj.onDidDismiss().then(modal => {
        if (modal.role == "success") {
          this.getErrorList();
        }
      });
    });
  }
}
